import { Outlet } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { Header } from './Header';
import { StatusBar } from './StatusBar';

export const AppLayout = () => {
  return (
    <div className="flex h-screen flex-col bg-gray-50">
      <Header />
      <main className="flex-1 min-h-0">
        <Outlet />
      </main>
      <StatusBar />
      <Toaster />
    </div>
  );
};
